module.exports = __webpack_public_path__ + "img/step-1.792491ca.png";